// „Filtern“ in Kunden & Anlagen (E3, S5): nur im Browser, über die Liste,
// die schon da ist – nach Name, Ort, PLZ oder Straße. Groß und klein,
// Umlaute und Akzente zählen nicht („muller“ findet „Müller“). Die echte
// Suche über alles kommt in Stufe 2 (der Platzhalter „Suchen“ oben).

import type { KundenZeile } from "@happy-energy/kern";

/** Für den Vergleich: klein, ohne Akzente, ß als ss, Leerraum zusammengezogen. */
export function vergleichsText(text: string): string {
  return text
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/ß/g, "ss")
    .replace(/\s+/g, " ")
    .trim();
}

/** Die Zeilen, die zu allen Wörtern passen – leer: alle. */
export function kundenFiltern<Z extends Pick<KundenZeile, "kunde" | "objekt">>(zeilen: readonly Z[], text: string): Z[] {
  const woerter = vergleichsText(text).split(" ").filter(Boolean);
  if (woerter.length === 0) return [...zeilen];
  return zeilen.filter((z) => {
    const heu = vergleichsText(`${z.kunde.name} ${z.objekt.strasse} ${z.objekt.plz} ${z.objekt.ort}`);
    return woerter.every((w) => heu.includes(w));
  });
}
